import { render, staticRenderFns } from "./CustomCardTable.vue?vue&type=template&id=dd59f1e6&scoped=true&"
import script from "./CustomCardTable.vue?vue&type=script&lang=js&"
export * from "./CustomCardTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomCardTable.vue?vue&type=style&index=0&id=dd59f1e6&scoped=true&lang=scss&"
import style1 from "./CustomCardTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd59f1e6",
  null
  
)

export default component.exports